import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.less'],
  animations: [
    trigger('slideOpen', [
      state('void', style({height: 0})),
      transition('* => *', [
        animate('200ms ease-in-out')
      ])
    ])
  ]
})

export class DescriptionComponent implements OnInit {
  public open: boolean = false;
  @Input() title: string;

  constructor() { }

  ngOnInit() {
  }

  public toggle() {
    this.open = !this.open;
    return false;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/description/description.component.ts